import { APIClient } from "helpers/api_helper";

const api = new APIClient();

export async function getPlayers() {
  try {
    const response = await api.get("/merchant/users/purchased-players", null);
    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error("Users could not be loaded");
  }
}
